import { getQueryStringParameter } from '@sonar-software/sonar-ts-lib';
import { useAuthToken } from '@hooks';
export const ExtensionAuthClose = () => {
    const { isLoggedIn } = useAuthToken();
    if (isLoggedIn) {
        const { search } = window.location;
        const extension = getQueryStringParameter(search, 'extension');
        if (extension) {
            window.close();
        }
    }
    return null;
};
